'use client';

import Header from '@/components/Header';
import About from '@/components/About';
import Footer from '@/components/Footer';

export default function AboutPageView() {
  return (
    <>
      <Header appearance="solid" />
      <main>
        <About variant="page" />
        <Footer />
      </main>
    </>
  );
}
